import React, { useState, useContext, useEffect } from 'react';
import { FaShoppingCart, FaUser, FaHeadset, FaPhoneAlt, FaEnvelope, FaBars, FaSearch, FaTimes, FaCoins, FaGift, FaCheckCircle } from 'react-icons/fa';
import Logo from '../assets/images/astha-logo.png';
import Search from '../pages/Search';
import { HeaderContext } from '../context/HeaderContext';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { config } from '../config';

const Header = () => {
  const {
    bonus,
    coinPackages,
    categories,
    contactInfo,
    logo,
    headerMenus,
    loading,
    error,
    imageUrl,
    searchProducts,
    showResults,
    handleSearch,
    setShowResults,
  } = useContext(HeaderContext);

  const apiUrl = config.apiUrl;

  const [searchOpen, setSearchOpen] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [categoryOpen, setCategoryOpen] = useState(false);
  const [loginOpen, setLoginOpen] = useState(false);
  const [phone, setPhone] = useState('');
  const [user, setUser] = useState(null);
  const [loginError, setLoginError] = useState('');
  const [showOfferNotification, setShowOfferNotification] = useState(true);
  const [paymentModalOpen, setPaymentModalOpen] = useState(false);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [paymentForm, setPaymentForm] = useState({
    name: '',
    wallet_number: '',
    phone: '',
    coin_package_id: '',
  });
  const [paymentSuccess, setPaymentSuccess] = useState(false);
  const navigate = useNavigate();

  const clearSearch = () => {
    setSearchText('');
    setShowResults(false);
  };

  useEffect(() => {
    const checkLoggedInUser = async () => {
      const token = localStorage.getItem('authToken');
      if (token) {
        try {
          const response = await axios.get(`${apiUrl}/user`, {
            headers: {
              'Authorization': `Bearer ${token}`
            }
          });
          setUser(response.data);
          setShowOfferNotification(false);
        } catch (err) {
          localStorage.removeItem('authToken');
        }
      }
    };

    checkLoggedInUser();
  }, [apiUrl]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoginError('');

    if (!phone.match(/^01[3-9]\d{8}$/)) {
      setLoginError('সঠিক মোবাইল নম্বর দিন (১১ ডিজিট, 01 দিয়ে শুরু)');
      return;
    }

    try {
      const response = await axios.post(`${apiUrl}/userlogin`, { phone });
      
      if (response.data.user) {
        setUser(response.data.user);
        localStorage.setItem('authToken', response.data.token);
        localStorage.setItem('phone', phone);
        setLoginOpen(false);
        setShowOfferNotification(false);
        window.location.reload();
      } else {
        setLoginError('লগইন সফল হয়নি');
      }
    } catch (err) {
      if (err.response && err.response.status === 404) {
        setLoginError('এই নম্বর দিয়ে কোন ইউজার নেই');
      } else {
        setLoginError('লগইনে সমস্যা হয়েছে, পরে চেষ্টা করুন');
        console.error('Login error:', err);
      }
    }
  };

  const handleLogout = async () => {
    try {
      const token = localStorage.getItem('authToken');
      
      if (token) {
        await axios.post(`${apiUrl}/logout`, {}, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
      }
    } catch (err) {
      console.error('Logout error:', err);
    } finally {
      localStorage.removeItem('authToken');
      localStorage.removeItem('token');
      localStorage.removeItem('phone');
      
      setUser(null);
      setPhone('');
      setLoginOpen(false);
      window.location.reload();
    }
  };

  const openPaymentModal = (pkg) => {
    setSelectedPackage(pkg);
    setPaymentForm({
      name: user?.name || '',
      wallet_number: '',
      phone: user?.phone || '',
      coin_package_id: selectedPackage?.id || '',
    });
    setPaymentModalOpen(true);
    setPaymentSuccess(false);
  };


  const handlePaymentSubmit = async (e) => {
    e.preventDefault();
    // Here you would typically send the payment details to your backend
    // For demonstration, we'll simulate a successful payment after 2 seconds
    
    try {
      // Simulate API call
      await new Promise(resolve => setTimeout(resolve, 2000));
      
      const response = await axios.post(`${apiUrl}/cointransactions`, {
        coin_package_id: selectedPackage.id,
        name: user.name,
        ...paymentForm
      });
      
      setPaymentSuccess(true);
      
      // Refresh user coins after successful payment
      if (user) {
        const token = localStorage.getItem('authToken');
        const response = await axios.get(`${apiUrl}/user`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        setUser(response.data);
      }
      
    } catch (err) {
      console.error('Payment error:', err);
    }
  };


  if (error) return <div className="bg-red-100 text-red-700 p-4 text-center">Error: {error}</div>;

  return (
    <>
    
    {/* Special Offer Notification for Non-logged in Users */}
    {!user && showOfferNotification && bonus && (
        <div className="bg-gradient-to-r from-blue-600 to-blue-800 text-white py-2 px-4 text-center text-sm relative">
            <div className="container mx-auto flex items-center justify-center">
                <FaGift className="mr-2 text-yellow-300" />
                <span>
                    প্রথম কেনাকাটায় {bonus.first_reg_bonus} {bonus.coin_name} ফ্রি + {Math.round(bonus.bonus_percentage)}% {bonus.coin_name} অতিরিক্ত বোনাস!
                </span>
                <button 
                    onClick={() => setShowOfferNotification(false)}
                    className="absolute right-4 top-1/2 transform -translate-y-1/2 text-white hover:text-yellow-300"
                >
                    <FaTimes />
                </button>
            </div>
        </div>
    )}

      {/* Top Announcement Bar */}
      <div className="bg-gradient-to-r from-green-600 to-green-700 text-white py-2 text-sm">
        <div className="container mx-auto px-4 flex flex-col md:flex-row justify-between items-center">
          <p className="mb-2 md:mb-0 text-center md:text-left">Welcome to Our Online Store!</p>
          <div className="flex flex-wrap justify-center gap-x-4 gap-y-1">
            <a href={`tel:${contactInfo.phone}`} className="flex items-center hover:text-green-100 transition-colors">
              <FaPhoneAlt className="mr-1" /> {contactInfo.phone}
            </a>
            <a href={`mailto:${contactInfo.email}`} className="flex items-center hover:text-green-100 transition-colors">
              <FaEnvelope className="mr-1" /> {contactInfo.email}
            </a>
          </div>
        </div>
      </div>
      
    <header className="sticky top-0 z-40 bg-white shadow-sm">
      
      {/* Main Header */}
      <div className="py-3 px-4 border-b border-gray-200">
        <div className="container mx-auto">
          {/* Mobile Top Row */}
          <div className="flex md:hidden justify-between items-center mb-3">
            <button 
              className="text-gray-700 p-2 rounded-full hover:bg-gray-100 transition-colors"
              onClick={() => setCategoryOpen(!categoryOpen)}
            >
              <FaBars />
            </button>
            
            <a href="/" className="mx-auto">
              <img src={`${imageUrl}/${logo?.logo}`} alt="Logo" className="h-10" />
            </a>
            
            <div className="flex items-center space-x-3">
              {user && (
                <div className="flex items-center bg-yellow-50 px-2 py-1 rounded-full border border-yellow-100">
                  <FaCoins className="text-yellow-500 mr-1" />
                  <span className="text-xs font-medium text-yellow-700">
                    {user.points} {bonus.coin_name}
                  </span>
                </div>
              )}
              <button 
                className="text-gray-700 p-2 rounded-full hover:bg-gray-100 transition-colors"
                onClick={() => setSearchOpen(!searchOpen)}
              >
                <FaSearch />
              </button>
              <button 
                className="text-gray-700 p-2 rounded-full hover:bg-gray-100 transition-colors"
                onClick={() => setLoginOpen(true)}
              >
                <FaUser />
              </button>
            </div>
          </div>

          {/* Desktop Top Row */}
          <div className="hidden md:flex items-center justify-between">
            {/* Logo */}
            <a href="/" className="mr-6">
              <img src={`${imageUrl}/${logo?.logo}`} alt="Logo" className="h-12" />
            </a>

            {/* Search Bar */}
            <div className="flex-grow max-w-2xl mx-4">
              <form onSubmit={(e) => {
                e.preventDefault();
                handleSearch(searchText);
              }} className="relative">
                <input 
                  type="text" 
                  placeholder="Search products..." 
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                  className="w-full px-5 py-2 border border-gray-300 rounded-full focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent shadow-sm" 
                />
                {searchText && (
                  <button 
                    type="button"
                    onClick={clearSearch}
                    className="absolute right-12 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700"
                  >
                    <FaTimes />
                  </button>
                )}
                <button 
                  type="submit"
                  className="absolute right-0 top-0 h-full px-4 bg-green-600 text-white rounded-r-full hover:bg-green-700 transition flex items-center"
                >
                  <FaSearch />
                </button>
              </form>
            </div>

            {/* User Actions */}
            <div className="flex items-center space-x-4">
              {user && (
                <div className="flex items-center bg-yellow-50 px-3 py-1.5 rounded-full border border-yellow-100 mr-2">
                  <FaCoins className="text-yellow-500 mr-2" />
                  <span className="font-medium text-yellow-700">
                    {user.points} {bonus.coin_name}
                  </span>
                </div>
              )}
              
              <button 
                className="flex items-center text-gray-700 hover:text-green-600 transition-colors group"
                onClick={() => setLoginOpen(true)}
              >
                <div className="relative p-2 group-hover:bg-green-50 rounded-full">
                  <FaUser className="text-lg" />
                </div>
                <span className="ml-2 hidden lg:inline-block">
                  {user ? user.name : 'Account'}
                </span>
              </button>
              
              <a href="/contact" className="flex items-center text-gray-700 hover:text-blue-600 transition-colors">
                <div className="p-2 hover:bg-blue-50 rounded-full">
                  <FaHeadset className="text-lg" />
                </div>
                <span className="ml-2 hidden lg:inline-block">Support</span>
              </a>
            </div>
          </div>

          {/* Mobile Search */}
          {searchOpen && (
            <form onSubmit={(e) => {
              e.preventDefault();
              handleSearch(searchText);
            }} className="mt-3 md:hidden flex">
              <input 
                type="text" 
                placeholder="Search products..." 
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                className="flex-grow px-4 py-2 border border-gray-300 rounded-l-lg focus:outline-none" 
              />
              <button 
                type="submit"
                className="px-4 py-2 bg-green-600 text-white rounded-r-lg hover:bg-green-700 transition"
              >
                <FaSearch />
              </button>
            </form>
          )}
        </div>
      </div>

      {/* Navigation */}
      <div className="bg-white border-b border-gray-200 shadow-xs">
        <div className="container mx-auto px-4">
          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center justify-between">
            <div className="relative">
              <button
                className="flex items-center bg-green-600 hover:bg-green-700 text-white font-medium px-5 py-2.5 rounded-lg transition-colors"
                onClick={() => setCategoryOpen(!categoryOpen)}
              >
                <FaBars className="mr-2" />
                <span>All Categories</span>
              </button>
              
              {categoryOpen && (
              <div className="absolute top-full left-0 mt-1 w-64 bg-white rounded-lg shadow-xl z-50 border border-gray-200">
                <ul className="py-2">
                  {/* All Products লিঙ্ক একবারই দেখান */}
                  <li>
                    <a 
                      href="/shop" 
                      className="block px-5 py-2.5 hover:bg-gray-50 text-gray-800 transition-colors flex items-center"
                    >
                      <span className="truncate">All Products</span>
                    </a>
                  </li>
                  
                  {/* ক্যাটাগরি লুপ */}
                  {categories.map((category) => (
                    <li key={category.id}>
                      <a 
                        href={`/category/${category.id}`} 
                        className="block px-5 py-2.5 hover:bg-gray-50 text-gray-800 transition-colors flex items-center"
                      >
                        <span className="truncate">{category.name}</span>
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            )}
            </div>
            
            <nav className="flex-1 ml-6">
              <ul className="flex space-x-1">
                {headerMenus.map((menu) => (
                  <li key={menu.id}>
                    <a 
                      href={menu.url} 
                      className="inline-block px-4 py-3 text-gray-700 hover:text-green-600 hover:bg-gray-50 rounded-lg transition-colors font-medium"
                    >
                      {menu.name}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          </div>

          {/* Mobile Category Drawer - Improved Version */}
          {categoryOpen && (
            <div className="md:hidden fixed inset-0 z-50">
              {/* Overlay with smooth transition */}
              <div 
                className="absolute inset-0 bg-black bg-opacity-50 transition-opacity duration-300"
                onClick={() => setCategoryOpen(false)}
              />
              
              {/* Drawer with slide-in animation */}
              <div className="absolute top-0 left-0 h-full w-4/5 max-w-xs bg-white shadow-xl transform transition-transform duration-300 ease-in-out">
                {/* Drawer Header */}
                <div className="flex items-center justify-between p-4 border-b border-gray-200 bg-gray-50">
                  <h3 className="text-lg font-semibold text-gray-800">Categories</h3>
                  <button 
                    onClick={() => setCategoryOpen(false)}
                    className="p-1 rounded-full hover:bg-gray-200 transition-colors"
                    aria-label="Close menu"
                  >
                    <FaTimes className="w-5 h-5 text-gray-500" />
                  </button>
                </div>
                
                {/* Drawer Content */}
                <div className="overflow-y-auto h-[calc(100%-56px)]">
                  {/* All Products Link */}
                  <a 
                    href="/shop" 
                    className="block px-5 py-3.5 text-gray-800 hover:bg-blue-50 transition-colors border-b border-gray-100 flex items-center"
                    onClick={() => setCategoryOpen(false)}
                  >
                    <span className="font-medium">All Products</span>
                  </a>
                  
                  {/* Categories List */}
                  <ul>
                    {categories.map((category) => (
                      <li key={`mobile-cat-${category.id}`}>
                        <a
                          href={`/category/${category.id}`}
                          className="block px-5 py-3.5 text-gray-700 hover:bg-blue-50 transition-colors border-b border-gray-100"
                          onClick={() => setCategoryOpen(false)}
                        >
                          <div className="flex items-center">
                            <span className="truncate">{category.name}</span>
                            {category.new && (
                              <span className="ml-2 px-2 py-0.5 bg-green-100 text-green-800 text-xs rounded-full">New</span>
                            )}
                          </div>
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Search Results */}
      {showResults && (
        <div className="bg-white shadow-lg">
          <Search products={searchProducts} />
        </div>
      )}

      {/* Login Modal */}
      {loginOpen && bonus && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-md overflow-hidden">
            <div className="flex justify-between items-center p-5 border-b">
              <h3 className="text-xl font-semibold">{user ? 'My Account' : 'Login'}</h3>
              <button 
                onClick={() => {
                  setLoginOpen(false);
                  setLoginError('');
                  setPhone('');
                }}
                className="text-gray-500 hover:text-gray-700 p-1 rounded-full hover:bg-gray-100"
              >
                <FaTimes />
              </button>
            </div>

            <div className="p-5">
              {!user ? (
                <>
                  <div className="mb-5 bg-blue-50 p-4 rounded-lg border border-blue-100">
                    <div className="flex items-start">
                      <FaGift className="text-blue-600 mt-1 mr-3 flex-shrink-0" />
                      <div>
                        <h4 className="font-bold text-blue-800 mb-1">বিশেষ অফার!</h4>
                        <p className="text-sm text-blue-700">
                          প্রথম কেনায় পাচ্ছেন {bonus.first_reg_bonus} {bonus.coin_name} এবং {Math.round(bonus.bonus_percentage)}% {bonus.coin_name} অতিরিক্ত বোনাস!
                        </p>
                      </div>
                    </div>
                  </div>

                  <form onSubmit={handleLogin}>
                    <div className="mb-5">
                      <label className="block text-gray-700 mb-2 font-medium">মোবাইল নম্বর</label>
                      <input
                        type="tel"
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                        placeholder="01XXXXXXXXX"
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent"
                        required
                      />
                      {loginError && (
                        <p className="text-red-500 text-sm mt-2 flex items-center">
                          <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                          </svg>
                          {loginError}
                        </p>
                      )}
                    </div>
                    <button
                      type="submit"
                      className="w-full bg-gradient-to-r from-green-600 to-green-700 text-white py-3 rounded-lg hover:from-green-700 hover:to-green-800 transition-all font-medium shadow-md"
                    >
                      লগইন
                    </button>
                  </form>
                </>
              ) : (
                <div>
                  <div className="flex items-start mb-6">
                    <div className="bg-green-100 p-3 rounded-full mr-4">
                      <FaUser className="text-green-600 text-xl" />
                    </div>
                    <div>
                      <h4 className="font-bold text-lg">{user.name}</h4>
                      <p className="text-gray-600">{user.phone}</p>
                      <div className="flex items-center mt-2 bg-yellow-100 px-3 py-1 rounded-full w-max">
                        <FaCoins className="text-yellow-600 mr-2" />
                        <span className="font-bold">{user.points} {bonus.coin_name}</span>
                      </div>
                    </div>
                  </div>

                  {coinPackages && coinPackages.length > 0 && (
                    <div className="mb-6">
                      <h3 className="text-lg font-semibold text-gray-800 mb-3">কয়েন প্যাকেজ কিনুন</h3>
                      <div className="grid gap-3">
                        {coinPackages.map((pkg) => (
                          <div 
                            key={pkg.id} 
                            className="bg-white rounded-lg border border-gray-200 hover:border-green-300 transition-colors overflow-hidden"
                          >
                            <div className="p-4">
                              <div className="flex justify-between items-start mb-2">
                                <div className="flex items-center">
                                  <div className="bg-yellow-100 p-2 rounded-full mr-3">
                                    <FaCoins className="text-yellow-500" />
                                  </div>
                                  <h4 className="font-medium text-gray-800">{pkg.name}</h4>
                                </div>
                                <span className="text-lg font-bold text-gray-900">
                                  {pkg.coins} {bonus.coin_name}
                                </span>
                              </div>
                              
                              <div className="flex justify-between items-center">
                                <div>
                                  {pkg.bonus && (
                                    <span className="bg-green-100 text-green-800 text-xs font-medium px-2 py-0.5 rounded">
                                      +{pkg.bonus}% বোনাস
                                    </span>
                                  )}
                                  {pkg.popular && (
                                    <span className="ml-2 bg-blue-100 text-blue-800 text-xs font-medium px-2 py-0.5 rounded">
                                      জনপ্রিয়
                                    </span>
                                  )}
                                </div>
                                <button 
                                  onClick={() => openPaymentModal(pkg)}
                                  className="bg-gradient-to-r from-yellow-500 to-yellow-600 hover:from-yellow-600 hover:to-yellow-700 text-white font-medium py-1.5 px-4 rounded-lg transition-all text-sm"
                                >
                                  কিনুন {pkg.price && `${pkg.price}৳`}
                                </button>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  <button
                    onClick={handleLogout}
                    className="w-full bg-gray-100 text-gray-800 py-3 rounded-lg hover:bg-gray-200 transition font-medium border border-gray-200"
                  >
                    লগআউট
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Payment Modal */}
      {paymentModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-md overflow-hidden">
            <div className="flex justify-between items-center p-5 border-b">
              <h3 className="text-xl font-semibold">পেমেন্ট সম্পন্ন করুন</h3>
              <button 
                onClick={() => {
                  setPaymentModalOpen(false);
                  setPaymentSuccess(false);
                }}
                className="text-gray-500 hover:text-gray-700 p-1 rounded-full hover:bg-gray-100"
              >
                <FaTimes />
              </button>
            </div>

            <div className="p-5">
              {paymentSuccess ? (
                <div className="text-center py-6">
                  <div className="flex justify-center mb-4">
                    <FaCheckCircle className="text-green-500 text-5xl" />
                  </div>
                  <h4 className="text-xl font-bold text-gray-800 mb-2">পেমেন্ট সফল হয়েছে!</h4>
                  <p className="text-gray-600 mb-4">
                    আপনার অ্যাকাউন্টে {selectedPackage.coins} {bonus.coin_name} যোগ করা হয়েছে।
                  </p>
                  <button
                    onClick={() => setPaymentModalOpen(false)}
                    className="w-full bg-green-600 text-white py-2 rounded-lg hover:bg-green-700 transition"
                  >
                    ঠিক আছে
                  </button>
                </div>
              ) : (
                <>
                  <div className="bg-blue-50 p-4 rounded-lg border border-blue-100 mb-5">
                    <h4 className="font-bold text-blue-800 mb-2">বিকাশ/নগদে পেমেন্ট করুন</h4>
                    <div className="space-y-2">
                      <p className="text-sm text-gray-700">
                        1. বিকাশ/নগদ অ্যাপে যান এবং "Send Money" নির্বাচন করুন
                      </p>
                      <p className="text-sm text-gray-700">
                        2. নিচের নাম্বারে {selectedPackage?.price}৳ পাঠান:
                      </p>
                      <p className="text-lg font-bold text-center bg-white p-2 rounded">
                        {contactInfo.tnx_number || '01XXXXXXXXX'}
                      </p>
                      <p className="text-sm text-gray-700">
                        3. নিচের ফর্মে ট্রানজেকশন করা নম্বর দিন এবং আপনার মোবাইল নম্বর দিন
                      </p>
                    </div>
                  </div>

                  <form onSubmit={handlePaymentSubmit}>
                    <div className="mb-4">
                      <label className="block text-gray-700 mb-1 font-medium">বিকাশ/নগদ নাম্বার দিন</label>
                      <input
                        type="text"
                        name='wallet_number'
                        value={paymentForm.wallet_number}
                        onChange={(e) => setPaymentForm({ ...paymentForm, wallet_number: e.target.value })}
                        placeholder="01XXXXXXXXX"
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
                        required
                      />
                    </div>

                    <div className="mb-4">
                      <label className="block text-gray-700 mb-1 font-medium">আপনার মোবাইল নম্বর</label>
                      <input
                        type="tel"
                        value={paymentForm.phone}
                        onChange={(e) => setPaymentForm({...paymentForm, phone: e.target.value})}
                        placeholder="01XXXXXXXXX"
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
                        required
                        readOnly
                      />
                    </div>

                    <div className="mb-4">
                      <label className="block text-gray-700 mb-1 font-medium">পরিমাণ</label>
                      <input
                        type="text"
                        value={`${selectedPackage?.price}৳`}
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg bg-gray-100"
                        readOnly
                      />
                    </div>

                    <button
                      type="submit"
                      className="w-full bg-gradient-to-r from-green-600 to-green-700 text-white py-3 rounded-lg hover:from-green-700 hover:to-green-800 transition-all font-medium shadow-md"
                    >
                      পেমেন্ট নিশ্চিত করুন
                    </button>
                  </form>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </header>
    </>
  );
};

export default Header;